module.exports = __webpack_public_path__ + "ky.b7acd796.svg";